import fetch from 'auth/FetchInterceptor'

const constantsService = {}
const api = '/constants'
constantsService.getConstants = async function () {
    try {
        let url = `${api}`
        const res = await fetch({
            url,
            method: 'get',
        })
        return res
    } catch (err) {
        console.log(err, 'show-err')
    }
}

export default constantsService